import React, { useState, FunctionComponent } from "react";

import SV from "../../styles/variables";
import styled, { css } from "styled-components";

import { OptionObj, Option } from "../../models/select";

interface IProps extends Option {
  updateSelected: () => void;
}

const FilterItem: FunctionComponent<IProps> = ({
  name,
  selected,
  color,
  svg,
  updateSelected
}) => {
  return (
    <SelectItem selected={selected} onClick={updateSelected} key={name}>
      <Checkbox selected={selected} />
      {svg && <Glasses src={svg} alt="" />}
      {color && <ColorDot color={color} selected={selected} />}
      <Name selected={selected}>{name}</Name>
    </SelectItem>
  );
};

interface SelectProps {
  selected: boolean;
  onClick?: () => void;
}

const SelectItem = styled.div<SelectProps>`
  align-items: center;
  align-self: center;
  background-color: white;
  color: ${p => (p.selected ? SV.colorP3 : "#c7c7c7")};
  display: flex;
  font-size: 16px;
  padding-top: 16px;
  justify-content: flex-start;

  font-weight: 300;
  line-height: 1;
` as React.FunctionComponent<SelectProps>;

const Check = css`
  content: "";
  border: 1px solid blue;
  border-top: 1px;
  border-right: 1px;
  display: block;
  height: 5px;
  left: 14px;
  top: 0px;
  transform: rotate(-45deg);
  transform: translate(4px, 3px) rotate(-45deg);
  width: 8px;
`;

const Checkbox = styled.span<SelectProps>`
  border: 1px #3a76eb solid;
  border-radius: 3px;
  display: block;
  height: 16px;
  width: 16px;
  cursor: pointer;

  &::after {
    ${p => (p.selected ? Check : "")}
  }
` as React.FunctionComponent<SelectProps>;

const Glasses = styled.img`
  margin-left: 8px;
  width: 44px;
`;

interface ColorProps {
  color: string;
  selected: boolean;
}

const ColorDot = styled.span<ColorProps>`
    border: 1px ${p => p.color} solid;
    border-radius: 50%;
    background-color: ${p => p.color}
    display: block;
    height: 12px;
    margin-left: 8px;
    margin-right: -4px;
    width: 12px;
  ` as React.FunctionComponent<ColorProps>;

const Name = styled.span<SelectProps>`
  display: block;
  color: black;
  font-weight: 300;
  margin-left: 8px;
  margin-left: 8px;
` as React.FunctionComponent<SelectProps>;

export default FilterItem;
